<template>
  <div class="top">
    <img
      v-if="config.mobile_logo"
      :src="config.mobile_logo"
      class="logo"
    />
    <i v-else class="logo"></i>
    <p class="title">{{config.web_title}}</p>
    <p v-if="config.web_slogan" class="slogan">{{config.web_slogan}}</p>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: mapState(['config']),
}
</script>
<style scoped lang="scss">
.top {
  margin-bottom: 40px;
  padding-top: 53px;
  .logo {
    display: block;
    height: 120px;
    width: 120px;
    border-radius: 18px;
    margin: 0 auto;
  }
  .title {
    margin-top: 32px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-weight: 500px;
    font-size: 38px;
    color: #000;
    line-height: 38px;
  }
  .slogan {
    margin-top: 22px;
    text-align: center;
    font-size: 26px;
    color: rgba(26,26,26,.66);;
    line-height: 26px;
  }
}
</style>
